<template>
	<div class="root">
		<MeetingHeader/>
		<div class="container">
			<div class="tips">
				<p style="margin-top: 10px;"><span style="color:#B176C5;">限时取消：</span>截止预约日期三日前24点，可自主免费取消预约，款项原路退回；超时限后不再接受取消，如未出席仍视为占用。</p>
				<!-- <p style="margin-top: 10px;"><span style="color:#B176C5;">注意事项：</span>如取消，该笔预约订单内所有预约时间段将一并取消，不支持部分取消。</p> -->
				<!-- <p style="margin-top: 10px;"><span style="color:#B176C5;">收费方式：</span>先预约使用，次月服务费税前结算抵扣</p> -->
			</div>
			<div class="searchbar">
				<DatePicker size='large' v-model='beginTime' class='datepicker' type="date" placeholder="选择日期"></DatePicker>
				<div class="division">至</div>
				<DatePicker size='large' v-model='endiTime' class='datepicker' type="date" placeholder="选择日期"></DatePicker>
				<Button size='large' class='button' type='primary' @click='search' :loading='loading'>搜索</Button>
			</div>
			<Tabs v-model="roomStatus">
				<TabPane label="全部" name="all"></TabPane>
				<TabPane label="已预约" name="pay"></TabPane>
		        <TabPane label="已使用" name="used"></TabPane>
		        <TabPane label="已确认" name="complete"></TabPane>
		        <TabPane label="已取消" name="cancel"></TabPane>
		    </Tabs>
		    <div class='load' v-if='loading'>
				<loading />
			</div>
		    <template v-else-if='showOrders.length'>
		    	<div class="order" v-for='order in showOrders'>
					<div class="header">
						<div class="orderno">订单号:{{order.OrderNo}}</div>
						<div class="status">{{getOrderStatusStr(order.IsRoom,order.OrderStatus)}}</div>
					</div>
					<div class="order-box">
						<div class="order-detail">
							<div class="room-img">
								<img :src="order.RoomImage" alt="">
							</div>
							<div class="rooms">
								<div class="desc" v-if='order.detail && order.detail[0]'>
									<div class='order-user'>
										<span>{{order.detail[0].BookUserName}}</span>
										<span>{{order.detail[0].MobilePhone}}</span>
									</div>
									<div class='order-user' v-if="order.detail[0].WithholdAccount">
										<span>代扣账号</span>
										<span>{{order.detail[0].WithholdAccount}}</span>
									</div>
									<div class='remark' v-if='order.detail[0].Description'>房间准备要求：{{order.detail[0].Description}}</div>
									<div class="store">{{order.detail[0].StoreName}}:</div>
								</div>
								<div class="room-item" v-for='detail in order.detail'>
									<div class="room-name">{{ detail.IsRoom ? detail.RoomName : `${detail.ProductName}&nbsp;×&nbsp;${detail.Qty}` }}</div>
									<div class="time" v-if='detail.IsRoom'>
										<div class="timerange">{{detail.BookingDate}} <span v-if='detail.BeginTime'>{{detail.BeginTime}} - {{detail.EndTime}}</span></div>
									</div>
									<div class="price">￥{{detail.Price * (detail.Qty || 1)}}</div>
									<!-- <div type="primary" class="confirm" size="small" ghost @click='cancelAlone("pay",detail)' v-if='detail?.IsRoom == 0 && detail?.DetailOrderStatus?.toLowerCase() == "unpay"'>去支付</div> -->
									<div type="primary" :class="getIsCancel('class',detail)" size="small" ghost @click='cancelAlone("cancel",detail)' v-if='cancelable(order,detail)'>{{getIsCancel('text',detail)}}</div>
								</div>
								<p class="order-tip" v-for="(t,i) in tip" v-html="t" :key="i"></p>
							</div>
							<div class='detail-right'>
								<div class="amount">总计：￥{{amount(order.detail)}}</div>
								<div class="buttons">
									<div class="cancel" @click='goConfirm(order)' v-if='canadd(order)'>追加产品</div>
									<div class="cancel" @click='cancelOrder(order)' v-if='cancelable(order)'>全部取消</div>
									<div class="confirm" @click='goPay(order)' v-if='orderStatus(order,"unpay")'>{{ order.IsRoom == 1 ? '确认预约去支付' : '去支付' }}</div>
								</div>
								<p class="pay-tip" style="margin-top: 10px;" v-if='orderStatus(order,"unpay")'>请在10分钟内完成支付</p>
							</div>
						</div>
						<div class="add-order" v-for="product in order.products">
							<div class="add-header">
								<div class="orderno">追加产品订单号: {{ product && product[0] ? product[0].OrderNo : '' }}</div>
								<div class="status">
									{{ product && product[0] ? getOrderStatusStr(product[0].IsRoom, product[0].OrderStatus) : '' }}
								</div>
							</div>
							<div class="order-box">
								<div class="order-detail">
									<div class="rooms">
										<div class="desc" v-if='product && product[0]'>
											<div class='order-user' style="margin-bottom: 20px;" v-if="product[0].WithholdAccount">
												<span>代扣账号</span>
												<span>{{product[0].WithholdAccount}}</span>
											</div>
										</div>
										<div class="room-item" v-for='item in product'>
											<div class="room-name">{{ item.IsRoom ? item.RoomName : `${item.ProductName}&nbsp;×&nbsp;${item.Qty}` }}</span></div>
											<div class="time" v-if='item.IsRoom'>
												<div class="timerange">{{item.BookingDate}} <span v-if='item.BeginTime'>{{item.BeginTime}} - {{item.EndTime}}</span></div>
											</div>
											<div class="price">￥{{item.Price * (item.Qty || 1)}}</div>
											<!-- <div type="primary" :class="getIsCancel('class',item)" size="small" ghost @click='cancelAlone("cancel",item)' v-if='cancelable(order,item)'>{{getIsCancel('text',item)}}</div> -->
										</div>
									</div>
									<div class='detail-right'>
										<div class="amount">总计：￥{{amount(product)}}</div>
										<div class="buttons" v-if="!(order.OrderStatus.toLowerCase() == 'cancel' || order.OrderStatus.toLowerCase() == 'used')">
											<div class="cancel" @click='cancelOrder(product[0])' v-if='cancelable(product[0])'>取消</div>
											<div class="confirm" @click='goPay(product[0])' v-if='product[0].OrderStatus.toLowerCase() == "unpay"'>去支付</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
		    </template>
		    <div v-else class='nodata'>
		    	暂无数据
		    </div>
		</div>
	</div>
</template>

<script>
	import MeetingHeader from '@/components/header/MeetingHeader'
	import loading from "@/components/order/loading";
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import util from '@/config/util'
	const now = new Date()
	export default {
		data() {
			return {
				beginTime:new Date(now.getFullYear(),now.getMonth(),1),
				endiTime:new Date(now.getFullYear(),now.getMonth()+2,0),
				orders:[],
				loading:false,
				roomStatus:'all',
				paySwitch:false,
				tip:[
					'* 可支持取消部分时段，部分退款；',
					'* 限时取消：截止预约日期三日前24点，可自主免费取消预约，款项原路退回；超时限后不再接受取消，如未出席仍视为占用。'
				]
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			MeetingHeader,
			loading,
		},
		computed: {
			...mapState({
				userInfo: state => state.common.userInfo,
			}),
			showOrders(){
				if (this.roomStatus == 'all') return this.orders
				return this.orders.filter(item=>item.OrderStatus.toLowerCase() == this.roomStatus)
			}
		},
		methods: {
			...mapActions([
				'getReservationOrdersAction',
				'postCancelReservationAction',
				'postAloneCancelAction',
				'getPaySwitchAction',
			]),
			orderStatus(item,status){
				return item.OrderStatus?.toLowerCase() == status
			},
			amount(orders){
				// const cartSum = orders.filter(item => item.DetailOrderStatus?.toLowerCase() != 'cancel').reduce((total, item) => total + ((item.Qty * item.Price) || 0), 0);
				const cartSum = orders.reduce((total, item) => total + ((item.Qty * item.Price) || 0), 0);
				return cartSum
			},
			async initData(){
				this.search()
				// let ss_021 = await this.getPaySwitchAction()
				// this.paySwitch = ss_021 == 1 // 切换为直接支付
			},
			getOrderStatusStr(isroom,status){
				const statusStrRoom = {
					unpay:'未确认',
					cancel:'已取消',
					pay:'已预约',
					complete:'已确认',
					used:'已使用'
				}
				const statusStr = {
					unpay:'未支付',
					cancel:'已取消',
					pay:'已支付',
					complete:'已确认',
					used:'已使用'
				}
				return isroom ? statusStrRoom[status?.toLowerCase()] : statusStr[status?.toLowerCase()]
			},
			getIsCancel(type,detail){
				if(type == 'class'){
					// if(detail?.IsRoom == 0 && detail?.DetailOrderStatus?.toLowerCase() == 'unpay') return 'confirm'
					return detail?.DetailOrderStatus?.toLowerCase() == 'cancel' ? 'disabled' : 'cancel'
				}
				if(type == 'text'){
					// if(detail?.IsRoom == 0 && detail?.DetailOrderStatus?.toLowerCase() == 'unpay') return '去支付'
					return detail?.DetailOrderStatus?.toLowerCase() == 'cancel' ? '已取消' : '取消'
				}
			},
			canadd(order){
				let status = order.OrderStatus?.toLowerCase()
				if(status == 'pay' && order.IsRoom == 1 && order.HasProduct == 1) return true
				return false
			},
			cancelable(order,detail){
				let now = new Date()
				let nowDate = new Date(now.getFullYear(),now.getMonth(),now.getDate())
				let BookingDate = detail ? detail.BookingDate : order.BookingDate
				let OrderStatus = detail ? detail.OrderStatus : order.OrderStatus
				if(detail?.DetailOrderStatus?.toLowerCase() == 'cancel') return true // 子订单已取消的显示
				// if(OrderStatus.toLowerCase() == 'unpay') return true // 未支付时不判断时间显示取消按钮
				if (BookingDate && new Date.dateFrom(BookingDate) - nowDate > 259200000 && OrderStatus.toLowerCase() != 'cancel') {
					return true
				}
				// if(detail?.IsRoom == 0 && detail?.DetailOrderStatus?.toLowerCase() == 'unpay') return true // 为产品且未支付
				return false
			},
			async search() {
				this.loading = true
				let response = await this.getReservationOrdersAction({
					BeginTime: util.formatDate.format(this.beginTime, 'yyyy-MM-dd'),
					EndTime: util.formatDate.format(this.endiTime, 'yyyy-MM-dd'),
				})

				let ordersMap = {}
				response.forEach(item => {
					if(!item.ParentOrderNo){
						if (ordersMap[item.ID]) {
							ordersMap[item.ID].detail.push({ ...item }) // 深拷贝，避免循环引用
						} else {
							ordersMap[item.ID] = { ...item, detail: [{ ...item }] }
						}
					}
				})
				let norooms = response.filter(u => u.ParentOrderNo)
				let orders = Object.values(ordersMap)
				orders.sort((a, b) => b.ID - a.ID)
				orders.forEach(item => {
					// 先筛选出属于这个房间的所有子订单
					const related = norooms.filter(obj => item.OrderNo == obj.ParentOrderNo)
					// 按 OrderNo 分组
					const grouped = {}
					related.forEach(obj => {
						if (!grouped[obj.OrderNo]) {
							grouped[obj.OrderNo] = []
						}
						grouped[obj.OrderNo].push({ ...obj }) // 深拷贝避免循环引用
					})

					// 转成数组结构
					item.products = Object.values(grouped)
				})

				this.orders = orders
				this.loading = false
			},
			goHome(){
				this.$router.push('/meeting/home')
			},
			goConfirm(order){
				this.$router.push(`/meeting/confirm?code=${order?.ID}`)
			},
			goPay(order){
				this.$router.push(`/meeting/payment?code=${order?.ID}`)
			},
			async cancelOrder(order){
				this.$Modal.confirm({
					title:'确定要取消预约吗?',
					content:'温馨提示：如取消该笔预约，订单内所有预约时段将一并取消！',
					loading:true,
					onOk:async ()=>{
						let response = await this.postCancelReservationAction({
							BookingId:order.ID,
						})
						this.$Modal.remove()
						setTimeout(()=>{
							if (typeof response.Value == 'string') {
								this.$Modal.info({
									title:'提示',
									content:response.Value
								})
								this.search()
							}
						}, 300)
						
					}
				})
				
			},
			async cancelAlone(type,detail){
				if(detail?.DetailOrderStatus?.toLowerCase() == 'cancel') return
				if(type == 'pay'){
					this.$router.push(`/meeting/payment?code=${detail?.BookingID}`) // 产品去支付
				}else{
					let content = detail.IsRoom ? `温馨提示：您正在取消 ${detail.RoomName} ${!detail.IsRoom?detail.Qty:''} ${detail.BookingDate} ${detail.BeginTime} - ${detail.EndTime} 的预约。` : `温馨提示：您正在取消 ${detail.ProductName} × ${detail.Qty}`
					this.$Modal.confirm({
						title:'确定要取消预约吗?',
						content:content,
						loading:true,
						onOk:async ()=>{
							let SS_019 = await this.postAloneCancelAction({
								VipNo:this.userInfo?.VipNo,
								BookingDetailId:detail.DetailId,
							})
							this.$Modal.remove()
							setTimeout(()=>{
								if (typeof SS_019.Value == 'string') {
									this.$Modal.info({
										title:'提示',
										content:SS_019.Value
									})
									this.search()
								}
							}, 300)
							
						}
					})
				}
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		display:block;
		background-color: #eee;
	}
	.container {
		padding-top:1rem;
		margin:auto;
		max-width: 1400px;
	}
	.searchbar {
		display:flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
		margin-bottom: 30px;
		.datepicker {
			width:200px;
			border-radius: 60px;
			box-shadow: 3px 8px 20px 0px rgba(0,0,0,0.1);
		}
		.division {
			margin:0 20px;
		}
		.button {
			margin-left: 20px;
			width:150px;
			border-radius: 20px;
		}
	}
	.order {
		margin-bottom: 20px;
		background-color:#ffffff;
		border-top-left-radius: 20px;
		border-top-right-radius: 20px;
		.header {
			background-color: $theme-color;
			color:white;
			display:flex;
			justify-content: space-between;
			padding:20px;
			@include fontSize($font-size-18);
			border-top-left-radius: 20px;
			border-top-right-radius: 20px;
		}
		.order-box{
			display:flex;
			flex-direction:column;
			.add-order{
				padding: 0 20px 0 190px;
				.add-header{
					background-color: $theme-color;
					color:#ffffff;
					display:flex;
					justify-content: space-between;
					padding:10px 20px;
					@include fontSize($font-size-16);
					border-top-left-radius: 20px;
					border-top-right-radius: 20px;
				}
			}
			.order-tip{
				@include fontSize($font-size-14);
			}
		}
		.order-detail {
			display:flex;
			align-items: center;
			padding:20px;
			.room-img {
				width:150px;
				height:150px;
				img {
					border-radius: 20px;
					width:100%;
					height:100%;
					object-fit: cover;
				}
			}
			.rooms {
				flex:1;
				padding-left: 20px;
				@include fontSize($font-size-16);
				.desc {
					.store {
						margin-bottom: 10px;
					}
					.order-user {
						font-weight: bold;
						margin-bottom: 5px;
						span {
							padding-right: 20px;
						}
					}
					.remark {
						margin-bottom: 10px;
					}
				}
				.room-item {
					margin-bottom: 10px;
					display:flex;
					.cancel,.confirm,.disabled{
						cursor: pointer;
						@include fontSize($font-size-12);
						width:60px;
						color: $warning-color;
						border:1px solid $warning-color;
						text-align: center;
						border-radius: 20px;
						height: 0.2rem;
						line-height: 0.2rem;
						margin-left: 10px;
					}
					.confirm{
						color: $theme-color;
						border:1px solid $theme-color;
					}
					.disabled{
						cursor: no-drop;
						color: #c5c8ce;
						border-color: #dcdee2;
					}
				}
				.room-name {
					font-weight: bold;
					margin-right: 20px;
				}
				.time {
					display:flex;
					.timerange {
						margin-right: 20px;
					}
				}
			}
			.detail-right {
				text-align: right;
			}
			.buttons {
				display: flex;
				align-self: flex-end;
				.cancel,.again {
					margin-right: 20px;
				}
				.cancel,.again,.confirm,.detail {
					cursor: pointer;
					@include fontSize($font-size-16);
					width:160px;
					color: $theme-color;
					border:1px solid $theme-color;
					text-align: center;
					border-radius: 20px;
					padding:5px 0;
				}
			}
		}
	}
	.nodata {
		text-align: center;
		margin-top: 30px;
	}
	@media (max-width: 768px){
		.tips {
			margin:10px;
		}
		.container {
			padding-top: 2.4rem;
		}
		.searchbar {
			margin-top: 10px;
			margin-bottom: 20px;
			.datepicker {
				width:200px;
			}
			.division {
				margin:0 10px;
			}
			.button {
				margin-left: 10px;
			}
		}
		.order {
			.order-box{
				.add-order{
					padding: 10px 10px 0px 10px;
				}
			}
			.order-detail {
				position:relative;
				flex-wrap: wrap;
				padding:10px;
				.detail-right {
					flex-direction: column;
					display:flex;
					align-items: center;
					width:100vw;
					margin-top: 10px;
					.buttons {
						align-self:center;
						justify-content: center;
						.cancel,.again,.confirm,.detail {
							width:120px;
						}
					}
				}
				.rooms {
					.room-item {
						flex-direction: column;
						.cancel,.disabled{
							margin-left: 0px;
							height: 24px;
							line-height: 24px;
						}
					}
				}
			}
		}
	}
	.price {
		color:red;
		font-weight: 500;
	}
	.amount {
		color:red;
		font-weight: 500;
		font-size: 18px;
		// @include fontSize($font-size-20);
		margin-bottom: 10px;
	}
</style>